export default __webpack_public_path__ + "static/media/Wall_Door_Right_Grey.256.0fd6b483.png";